import { FC, ReactElement } from 'react'
import ReactPaginate from 'react-paginate'
import { Container } from './style'

type PaginationProps = {
  totalPages: number
  page?: number
  onChange?: (value: number) => void
}

const Pagination: FC<PaginationProps> = ({ page, totalPages, onChange }): ReactElement => {
  return (
    <Container>
      <ReactPaginate
        pageCount={totalPages}
        pageRangeDisplayed={5}
        marginPagesDisplayed={2}
        forcePage={(page || 1) - 1}
        onPageChange={(d) => onChange && onChange(d.selected + 1)}
      />
    </Container>
  )
}

export default Pagination
